import TransportadoraEnderecoService from "@/services/TransportadoraEnderecoService";

export const transportadoraEndereco = {
  namespaced: true,
  state: {
    transportadoraEndereco: {},
  },
  actions: {
    getTransportadoraEndereco({ commit }, payload) {
      return TransportadoraEnderecoService.GetTransportadoraEndereco(
        payload
      ).then(
        (transportadoraEndereco) => {
          return Promise.resolve(transportadoraEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTransportadoraEndereco({ commit }, payload) {
      return TransportadoraEnderecoService.PostTransportadoraEndereco(
        payload
      ).then(
        (transportadoraEndereco) => {
          return Promise.resolve(transportadoraEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTransportadoraEndereco({ commit }, payload) {
      return TransportadoraEnderecoService.PutTransportadoraEndereco(
        payload
      ).then(
        (transportadoraEndereco) => {
          return Promise.resolve(transportadoraEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTransportadoraEndereco({ commit }, payload) {
      return TransportadoraEnderecoService.DeleteTransportadoraEndereco(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTransportadoraEnderecoOData({ commit }, payload) {
      return TransportadoraEnderecoService.GetTransportadoraEnderecoOData(
        payload
      ).then(
        (transportadoraEndereco) => {
          return Promise.resolve(transportadoraEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default transportadoraEndereco;
